import type { RouteRecordRaw } from 'vue-router'

export const usersRoutes: RouteRecordRaw[] = [
  {
    name: 'users',
    path: '/users',
    component: () => import('./views/UsersView.vue'),
    meta: {
      locationTypes: ['organization', 'singleLocation']
    }
  }
]
